import type {
    CartItemInterface,
    ConfigurableCartItem,
    ConfigurableLocalCartItem,
    SimpleCartItem,
    SimpleLocalCartItem,
} from '../types/front.graphql';

export type CartItem = ConfigurableLocalCartItem | SimpleLocalCartItem | SimpleCartItem | ConfigurableCartItem;

export enum CartItemTypeEnum {
    SIMPLE = 'SimpleCartItem',
    SIMPLE_LOCAL = 'SimpleLocalCartItem',
    CONFIGURABLE = 'ConfigurableCartItem',
    CONFIGURABLE_LOCAL = 'ConfigurableLocalCartItem',
}

export interface CartItemWithTypeInterface extends CartItemInterface {
    __typename?: CartItemTypeEnum;
}
export interface CartItemLocalInterface extends CartItemInterface {
    localId?: string; // Optional local ID for the item
    cartItemReferenceId?: string; // Optional reference ID for attached products
}

export type SimpleCartItemLocal = SimpleCartItem & {
    localId?: string; // Optional local ID for the item
};
export type ConfigurableCartItemLocal = ConfigurableCartItem & {
    localId?: string; // Optional local ID for the item
};

export enum CartItemStatusEnum {
    NO_STOCK = 102,
    LACK_OF_STOCK = 103,
}
